import { getTwoType } from '@/axios/api'

const sameTypeSec = {
  state: {
    sameType: [],
    sameBelongId: 0
  },
  mutations: {
    SET_TRAVLESEC (state, travleSec) {
      state.sameType = travleSec
    },
    SET_SAME_BELONG_ID (state, changeMarketType) {
      state.sameBelongId = changeMarketType
    }
  },
  actions: {
    getSameType ({ commit }, params) {
      getTwoType(params).then(res => {
        commit('SET_TRAVLESEC', res.data.data)
        // this.state.travleSec = res.data.data
      })
    }
  }
}

export default sameTypeSec



// WEBPACK FOOTER //
// ./src/store/modules/sameType.js